function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 23.1768,
    cy: 23,
    r: 23,
    fill: "#E8E8E8",
    style: {
      fill: "#E8E8E8",
      fill: "color(display-p3 0.9083 0.9083 0.9083)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7916 17.0397C18.6081 17.3456 18.2203 17.4361 17.9283 17.2465C17.6363 17.0569 17.5446 16.6561 17.7282 16.3544C18.0993 15.7425 18.1326 14.9323 17.8241 14.303C17.8157 14.2772 17.799 14.2514 17.7865 14.2255C17.432 13.5877 16.6979 13.1912 16.014 13.2645C15.3301 13.3334 14.6919 13.8936 14.5334 14.566C14.3601 15.2824 14.7333 16.0613 15.2591 16.363C15.8163 16.6909 15.5862 17.574 14.9505 17.574C14.8462 17.574 14.7378 17.5439 14.6419 17.4879C13.5781 16.8647 13.0146 15.5015 13.3198 14.2514C13.6118 13.0403 14.6669 12.1052 15.8889 11.9759C17.1524 11.8472 18.5076 12.5823 19.0627 13.9928C19.438 14.9754 19.3421 16.126 18.7916 17.0397Z",
    fill: "#F34036",
    style: {
      fill: "#F34036",
      fill: "color(display-p3 0.9529 0.2510 0.2118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9503 17.5739C14.846 17.5739 14.7376 17.5437 14.6417 17.4877C14.3915 17.3412 14.1703 17.1516 13.9785 16.9361C14.2455 16.6172 14.5458 16.3112 14.8752 16.0225C14.9795 16.1603 15.1087 16.2767 15.2589 16.3629C15.8161 16.6908 15.586 17.5739 14.9503 17.5739Z",
    fill: "#E11A17",
    style: {
      fill: "#E11A17",
      fill: "color(display-p3 0.8824 0.1020 0.0902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.791 17.0396C18.6075 17.3456 18.2197 17.436 17.9278 17.2464C17.6358 17.0568 17.544 16.656 17.7276 16.3543C18.0987 15.7424 18.132 14.9322 17.8235 14.303C18.2406 14.1565 18.6576 14.0531 19.0622 13.9927C19.4375 14.9753 19.3416 16.126 18.791 17.0396Z",
    fill: "#E11A17",
    style: {
      fill: "#E11A17",
      fill: "color(display-p3 0.8824 0.1020 0.0902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7327 24.3744C27.8411 24.4764 24.1769 26.5783 20.7349 28.5417C19.3445 29.3778 18.1192 30.0281 16.7186 31.1921C16.2349 31.5886 15.8512 32.1057 15.48 32.61C14.532 33.9126 14.4489 34.4191 14.3247 34.3166C14.3038 34.2994 14.2997 34.2692 14.2997 34.2433C14.2466 33.805 14.3636 33.5002 14.4165 33.1229C15.4282 26.1909 12.1868 23.3328 13.0318 19.6769C13.8603 16.242 18.3007 13.4718 21.5482 14.6562C26.1063 16.2134 27.3038 22.6776 31.7327 24.3744Z",
    fill: "#F8C73B",
    style: {
      fill: "#F8C73B",
      fill: "color(display-p3 0.9725 0.7804 0.2314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7913 27.8307C30.8027 29.1615 29.4528 30.176 28.0759 31.0561C26.5887 32.0068 25.0606 32.8998 23.4488 33.6063C21.8383 34.378 18.5286 35.395 16.5619 35.5769C16.2844 35.5916 15.9948 35.6018 15.7327 35.4957C15.4904 35.4112 15.3251 35.2431 15.2381 35.0273C14.8705 34.2315 15.3233 33.2729 15.8468 32.5767C17.5479 30.3597 23.1719 26.666 28.3764 25.5902C29.4343 25.3359 30.7352 24.9262 31.7371 25.425C32.2652 25.6963 32.4286 26.1508 32.3275 26.7387C32.2515 27.1462 32.0371 27.5014 31.7913 27.8307Z",
    fill: "#FEEEB7",
    style: {
      fill: "#FEEEB7",
      fill: "color(display-p3 0.9961 0.9333 0.7176)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7912 27.8309C30.8027 29.1617 29.4528 30.1763 28.0758 31.0564C26.5886 32.0071 25.0606 32.9001 23.4487 33.6066C23.115 33.7665 21.4642 34.2662 20.8991 34.4231C19.478 34.8218 18.0023 35.1436 16.534 34.9826C16.0905 34.9276 15.6083 34.8087 15.3293 34.4429C15.1631 34.2157 15.1265 33.8947 15.2855 33.5469C15.3617 33.428 15.4672 33.3412 15.6076 33.3098L15.9837 32.9594C20.0119 32.5821 23.948 31.2342 27.403 29.0713C28.5582 28.347 29.6676 27.5209 30.5092 26.4318C30.8471 25.9966 31.2157 25.4746 31.737 25.4253C32.2652 25.6966 32.4286 26.151 32.3275 26.739C32.2514 27.1465 32.0371 27.5017 31.7912 27.8309Z",
    fill: "#F7D78A",
    style: {
      fill: "#F7D78A",
      fill: "color(display-p3 0.9686 0.8431 0.5412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5049 33.1027C15.2736 31.1395 18.432 29.0931 20.0449 28.063C23.0846 26.1303 26.6218 24.4396 30.1515 23.9912C32.9922 23.6453 34.4729 25.8036 32.6877 28.1915C30.8965 30.6311 26.4861 33.1686 23.9617 34.2766C22.2541 35.0294 17.2127 36.8333 15.5336 36.1855C14.6057 35.8835 13.9357 34.6 14.5049 33.1027ZM30.3797 25.9595C26.9743 26.3891 23.6389 28.1052 21.0515 29.7502C19.9575 30.4496 15.9259 33.0432 16.2333 34.3344C16.9326 34.4865 20.3907 33.6956 23.2102 32.4528C25.2558 31.5545 28.7733 29.5236 30.3675 27.9103C30.6932 27.5848 31.4398 26.7644 31.5245 26.3076C31.601 25.8971 30.7638 25.9131 30.3797 25.9595Z",
    fill: "#EF9F27",
    style: {
      fill: "#EF9F27",
      fill: "color(display-p3 0.9373 0.6235 0.1529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9079 30.7206C26.3852 32.1975 24.8022 32.9572 23.373 32.4171C22.3192 32.0188 21.4139 30.8108 21.5679 29.61C21.6089 29.3018 21.9885 29.1146 22.2281 28.9378C23.0528 28.3519 23.9324 27.8608 25.0525 27.4793C25.2301 27.4198 25.497 27.2815 25.6828 27.2954C25.8543 27.311 25.9894 27.4676 26.1139 27.5779C27.0344 28.4088 27.2738 29.687 26.9079 30.7206Z",
    fill: "#F8C73B",
    style: {
      fill: "#F8C73B",
      fill: "color(display-p3 0.9725 0.7804 0.2314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6309 28.1954C26.354 28.1892 26.0857 28.1582 25.8087 28.152C24.1459 28.1024 22.5291 28.9719 21.6382 30.5089C21.5513 30.2158 21.5295 29.912 21.5682 29.61C21.6092 29.3018 21.9888 29.1146 22.2284 28.9378C23.0531 28.3519 23.9327 27.8608 25.0528 27.4793C25.2304 27.4198 25.4973 27.2815 25.6831 27.2954C25.8546 27.311 25.9897 27.4676 26.1142 27.5779C26.3154 27.7595 26.4877 27.9654 26.6309 28.1954Z",
    fill: "#FAB041",
    style: {
      fill: "#FAB041",
      fill: "color(display-p3 0.9804 0.6902 0.2549)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9537 21.2198C24.977 22.535 21.285 20.4243 21.189 16.6904C21.1723 15.9793 21.2933 15.2897 21.5477 14.6562C24.5284 15.6745 26.1278 18.8569 27.9537 21.2198Z",
    fill: "#EF9F27",
    style: {
      fill: "#EF9F27",
      fill: "color(display-p3 0.9373 0.6235 0.1529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0747 21.1778C28.5429 21.1778 30.5439 19.1101 30.5439 16.5596C30.5439 14.009 28.5429 11.9414 26.0747 11.9414C23.6064 11.9414 21.6055 14.009 21.6055 16.5596C21.6055 19.1101 23.6064 21.1778 26.0747 21.1778Z",
    fill: "#6DD356",
    style: {
      fill: "#6DD356",
      fill: "color(display-p3 0.4275 0.8275 0.3373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4028 18.7583L25.3535 14.3371C25.3498 14.0388 25.6592 13.803 26.0433 13.8104C26.4661 13.7831 26.7434 14.0638 26.7459 14.3609L26.7951 18.7822C26.7988 19.0805 26.4894 19.3163 26.1053 19.3088C25.7892 19.3186 25.4061 19.0911 25.4028 18.7583Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0576 26.2883C19.1078 27.1916 18.4591 28.084 17.6048 28.2821C16.7504 28.4802 15.7929 27.9571 15.4738 27.1146C15.2598 26.5499 15.3303 25.8734 15.6753 25.3829C16.0207 24.8917 16.9558 24.3675 17.5708 24.4758C18.3572 24.6141 19.0135 25.4961 19.0576 26.2883Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 23.449C19.4797 23.89 19.1631 24.3256 18.746 24.4223C18.3289 24.5191 17.8615 24.2637 17.7057 23.8524C17.6012 23.5767 17.6356 23.2465 17.804 23.007C17.9727 22.7672 18.4292 22.5113 18.7294 22.5641C19.1133 22.6317 19.4337 23.0623 19.4552 23.449Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0702 20.3881C14.0296 19.6833 14.2476 18.96 14.6683 18.4033C14.7361 18.3133 14.8618 18.2972 14.949 18.3676C15.0361 18.4378 15.0515 18.5678 14.9835 18.6576C14.622 19.1361 14.4345 19.7578 14.4695 20.3634C14.4761 20.4775 14.3919 20.5753 14.2818 20.582C14.1654 20.5877 14.0765 20.4975 14.0702 20.3881Z",
    fill: "#FDE77A",
    style: {
      fill: "#FDE77A",
      fill: "color(display-p3 0.9922 0.9059 0.4784)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3192 19.9367C15.3011 19.7026 15.3708 19.4624 15.5106 19.2776C15.5786 19.1878 15.704 19.1718 15.7915 19.242C15.8784 19.3125 15.8939 19.4423 15.8259 19.5323C15.747 19.6364 15.7077 19.7716 15.7181 19.9036C15.7269 20.0172 15.6448 20.1169 15.5347 20.1262C15.4207 20.1346 15.3278 20.0475 15.3192 19.9367Z",
    fill: "#FDE77A",
    style: {
      fill: "#FDE77A",
      fill: "color(display-p3 0.9922 0.9059 0.4784)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3098 11.2514L26.0397 9.95848C26.0164 9.84688 26.085 9.73688 26.193 9.71287C26.3014 9.68824 26.4075 9.75969 26.4307 9.8713L26.7008 11.1642C26.7241 11.2758 26.6555 11.3858 26.5475 11.4098C26.4421 11.4337 26.3336 11.365 26.3098 11.2514Z",
    fill: "#6F6ECF",
    style: {
      fill: "#6F6ECF",
      fill: "color(display-p3 0.4353 0.4314 0.8118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5896 11.6948C27.4817 11.6696 27.4142 11.5588 27.4386 11.4476C27.5608 10.8907 27.7251 10.3391 27.9269 9.80754C27.9671 9.70098 28.0835 9.64891 28.186 9.69069C28.2888 9.73226 28.3396 9.85214 28.2991 9.9585C28.1048 10.4707 27.9464 11.0023 27.8288 11.539C27.8042 11.6508 27.6969 11.7196 27.5896 11.6948Z",
    fill: "#6F6ECF",
    style: {
      fill: "#6F6ECF",
      fill: "color(display-p3 0.4353 0.4314 0.8118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7355 12.2502C28.5613 12.2502 28.4685 12.0327 28.591 11.9006L29.2779 11.1587C29.3539 11.076 29.4806 11.0731 29.5607 11.1522C29.6406 11.2312 29.6433 11.3619 29.567 11.4445L28.8801 12.1864C28.8408 12.2288 28.7881 12.2502 28.7355 12.2502Z",
    fill: "#6F6ECF",
    style: {
      fill: "#6F6ECF",
      fill: "color(display-p3 0.4353 0.4314 0.8118)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.c40bc6431942ceec9a5aa1e42b38dd3b.svg";
export { ForwardRef as ReactComponent };